import React from "react";

import {
  ProductCard as UIProductCard,
  type ProductCardProps as UIProductCardProps,
} from "@bared/ui";

import {
  ProductCardVisibilityObserver,
  ProductCardVisibilityObserverProps,
} from "~/components/ProductCardVisibilityObserver";

import { useWishlistToggle } from "~/hooks/useWishlist";

export type ProductCardProps = UIProductCardProps &
  Omit<ProductCardVisibilityObserverProps, "children">;

export function ProductCard({
  index,
  initialInView,
  googleAnalyticsItem,
  ...props
}: ProductCardProps) {
  const { toggleWishlist, isInWishlist } = useWishlistToggle({
    googleAnalyticsItem,
    productHandle: props.handle,
  });

  return (
    <ProductCardVisibilityObserver
      index={index}
      initialInView={initialInView}
      googleAnalyticsItem={googleAnalyticsItem}
    >
      {({ ref, onClick }) => (
        <UIProductCard
          {...props}
          ref={ref}
          onClick={onClick}
          isInWishlist={isInWishlist}
          onWishlistToggle={toggleWishlist}
        />
      )}
    </ProductCardVisibilityObserver>
  );
}
